import * as React from 'react';
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import Utils from "../../../Utils";
import * as toastr from "toastr";
import Axios from "../../../config/Axios";
import AgGridFooter from "../common/AgGridFooter";
import AgSelectAllHeader from "../common/AgSelectAllHeader";
import GlobalSearchHelpToolTip from "../common/GlobalSearchHelpToolTip";
import {ResizeActions} from "../InstanceGridEditor";
import AuditLogChangesModal from "../modals/AuditLogChangesModal";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import CustomDateComponent from "../../common/CustomDateComponent";
import {exportLogs} from "../../../actions/boCoreActions";
import history from "../../../config/history";
import AgHelpToolTip, {helpHeaderTemplate} from "../common/AgHeaderHelpToolTip";
import LoadingModal from "../modals/LoadinModal";
import AgGridUtils from "../../../AgGridUtils";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface Props {
    selectedUser: any;
}

interface State {
    resizeAction: string;
    columnDefs: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
    rowSelection: string;
    rowModelType: string;
    defaultColDef: any;
    logOldValue: string;
    logNewValue: string;
    rowBuffer: number;
    paginationPageSize: number;
    cacheOverflowSize: number;
    maxConcurrentDatasourceRequests: number;
    infiniteInitialRowCount: number;
    maxBlocksInCache: number;
    frameworkComponents: any;
}

class AuditLogGrid extends React.Component<Props, State> {
    auditLogChangesRef;

    constructor(props: Props) {
        super(props);
        this.state = {
            resizeAction: ResizeActions.FIT_CONTENT,
            columnDefs: [],
            gridApi: null,
            columnApi: null,
            loading: false,
            rowSelection: 'multiple',
            rowModelType: 'serverSide',
            defaultColDef: {
                sortable: true,
                minWidth: 150,
                flex: 1,
                filter: "agTextColumnFilter",
                floatingFilterComponentParams: {suppressFilterButton: true},
                floatingFilter: true,
                resizable: true,
                filterParams: {
                    applyButton: true,
                    suppressAndOrCondition: true
                },
                tooltipComponent: AgHelpToolTip,
                headerComponentParams: {
                    template: helpHeaderTemplate
                },
            },
            logOldValue: null,
            logNewValue: null,
            rowBuffer: 0,
            paginationPageSize: 10,
            cacheOverflowSize: 2,
            maxConcurrentDatasourceRequests: 1,
            infiniteInitialRowCount: 1000,
            maxBlocksInCache: 10,
            frameworkComponents: { agDateInput: CustomDateComponent },
        };
    }

    private gridOptions: any = {
        floatingFilter: true,
        resizable: true,
        singleClickEdit: true,
        suppressDragLeaveHidesColumns: true,
        rowSelection: "multiple",
        cacheQuickFilter: Utils.$(this.refs.quickFilterBox),
        onRowSelected: (params: any) => {
            setTimeout(() => {
                this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.onRowSelected(params);
                this.forceUpdate();
            }, 0)
        },
        onCellClicked: (params) => {
            if (params.column.colId === "instanceId") {
                this.saveGridState();
                localStorage.setItem('cameFromAuditLog', 'cameFromAuditLog');
                history.push(`${process.env.ENV_PREFIX}/instance/${params.value}?logId=${params.data.id}`);
            }
        }
    };

    saveGridState = () => {
        window['sortState'] = this.state.gridApi.gridOptionsWrapper.gridOptions.api.getSortModel();
        window['filterState'] = this.state.gridApi.gridOptionsWrapper.gridOptions.api.getFilterModel();
    };

    componentDidMount(): void {
        this.buildGrid();
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.selectedUser && this.props.selectedUser !== prevProps.selectedUser) {
            this.buildGrid();
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandler);
    }

    keydownHandler = (e) => {
        if (e.shiftKey && e.keyCode === 38) {
            e.preventDefault();
            $(this.refs.quickFilterBox).focus();
        }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 70) {
            Utils.$('#fit-content').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 86) {
            Utils.$('#view-log-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#export-log-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    onFilterTextBoxChanged = (e) => {
        if ((e.type === "keydown" && e.keyCode === 13) || e.type === "click") {
            this.state.gridApi.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
        if (e.keyCode === 9) {
            e.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    buildGrid = () => {
        const columnDefs = [
            {
                field: "quickFilter", hide: true, lockVisible: true,
                dataType: AttributeTypeEnum.TEXT
            },
            {
                headerName: "",
                width: 52,
                maxWidth: 52,
                checkboxSelection: true,
                cellRenderer: function (params) {
                    return `<label style="cursor: pointer; color:#5baeff">${params.value}</label>`
                },
                headerComponent: AgSelectAllHeader,
                headerTooltip: "",
                suppressSizeToFit: true,
                floatingFilter: false,
                filter: false
            },
            {
                field: 'stamp',
                dataType: AttributeTypeEnum.TIMESTAMP,
                headerName: "Timestamp",
                tooltipField: 'stamp',
                headerTooltip: "Timestamp",
                width: 200,
                editable: false,
                type: 'datetime'
/*              minWidth: 180,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: function(filterLocalDateAtMidnight, cellValue) {
                        var dateAsString = cellValue;
                        var dateParts = dateAsString.split('/');
                        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));

                        if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                            return 0;
                        }

                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }

                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    suppressAndOrCondition: true,
                    filterOptions: ['equals', 'greaterThanOrEqual', 'lessThanOrEqual', 'inRange'],
                },
                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },*/
            },
            {
                field: 'boKey',
                headerName: "Type",
                tooltipField: 'Type',
                headerTooltip: "Type",
                width: 200,
                editable: false,
                dataType: AttributeTypeEnum.TEXT,
                sortable: true
            },
            {
                field: 'instanceId',
                headerName: "Instance ID",
                tooltipField: 'instanceId',
                headerTooltip: "Instance ID",
                width: 200,
                cellRenderer: function (params) {
                    return `<label style="cursor: pointer; color:#5baeff">${params.value}</label>`
                },
                editable: false,
                dataType: AttributeTypeEnum.INT
            },
            {
                field: 'username',
                headerName: "Username",
                tooltipField: 'username',
                headerTooltip: "Username",
                width: 200,
                editable: false,
                dataType: AttributeTypeEnum.TEXT,
                sortable: true
            },
            {
                field: 'operation',
                headerName: "Changes",
                tooltipField: 'operation',
                headerTooltip: "Changes",
                width: 200,
                editable: false,
                dataType: AttributeTypeEnum.TEXT,
                sortable: false
            },
            {
                field: 'oldValue',
                headerName: "Old Value",
                tooltipField: 'oldValue',
                headerTooltip: "Old Value",
                filter: false,
                sortable: false,
                dataType: AttributeTypeEnum.TEXT,
                type: 'text'
            },
            {
                field: 'newValue',
                headerName: "New Value",
                tooltipField: 'newValue',
                headerTooltip: "New Value",
                filter: false,
                sortable: false,
                dataType: AttributeTypeEnum.TEXT,
                type: 'text'
            }
        ];

        if (this.state.gridApi) {
            this.state.gridApi.setServerSideDatasource(this.ServerSideDatasource());
        }

        this.setState({columnDefs}, () => this.addFilterIndex());
    };

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input" ).each(function( index ) {
            Utils.$(this).attr('id', 'log-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    onGridReady = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            if (localStorage.getItem('cameFromInstance')) {
                localStorage.removeItem('cameFromInstance');
                this.restoreGridState(params)
            }
            params.api.setServerSideDatasource(this.ServerSideDatasource());
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        });
    };

    restoreGridState = (gridOptions: any) => {
        gridOptions.api.setSortModel(window['sortState']);
        gridOptions.api.setFilterModel(window['filterState']);
        if (window['filterState'] && window['filterState']['quickFilter']) {
            $(this.refs.quickFilterBox).val(window['filterState']['quickFilter'].filter)
        }
    };

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ',' + sortObj[sortKeys[0]]}` : '';
                let filter = generateFilterData(params);
                if (this.props.selectedUser.value !== '') {
                    filter['username'] = this.props.selectedUser.value;
                }
                Axios.instanceV2.post(`audit-log?size=${limit}&page=${page}${sort}`, filter)
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            return {
                                id: item.id,
                                instanceId: item.instanceId,
                                stamp: Utils.utcToLocalDate(item.stamp),
                                operation: item.operation,
                                oldValue: JSON.stringify(item.oldValue),
                                newValue: JSON.stringify(item.newValue),
                                username: item.username,
                                boKey: item.boKey
                            }
                        });
                        if (gridData.length === 0) {
                            this.state.gridApi.showNoRowsOverlay()
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);
                            if (this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }
                            this.state.gridApi.sizeColumnsToFit();
                            this.forceUpdate();
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    onInput = (e) => {
        if (e.currentTarget.value === '' && !e.nativeEvent.inputType) {
            // 'X' button inside the input is pressed
            this.state.gridApi.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
    };

    onResizeColumns = () => {
        if (this.state.resizeAction === ResizeActions.FIT_SCREEN) {
            this.fitScreenColumns();
        } else {
            this.autoSizeAllColumns();
        }
    };

    fitScreenColumns = () => {
        this.state.columnApi.resetColumnState();
        this.addFilterIndex();
        this.state.gridApi.sizeColumnsToFit();
        if (this.state.resizeAction !== ResizeActions.FIT_CONTENT) {
            this.setState({
                resizeAction: ResizeActions.FIT_CONTENT
            });
        }
    };

    autoSizeAllColumns = () => {
        let allColumnIds = [];
        this.state.columnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column.colId);
        });
        this.state.columnApi.autoSizeColumns(allColumnIds, false);

        if (this.state.resizeAction !== ResizeActions.FIT_SCREEN) {
            this.setState({
                resizeAction: ResizeActions.FIT_SCREEN
            });
        }
    };

    onViewLog = (e) => {
        const rows = this.state.gridApi.getSelectedRows();
        if (rows.length === 1) {
            this.setState({
                logOldValue: JSON.parse(rows[0].oldValue),
                logNewValue: JSON.parse(rows[0].newValue)
            }, () => {
                this.auditLogChangesRef.open();
            });
        } else if (rows.length === 0) {
            toastr.warning("Please select one log entry");
        } else {
            toastr.warning("Please select only one log entry");
        }
    };

    onLogExport = () => {
        this.setState({
            loading: true
        }, () => {
            exportLogs({username: this.props.selectedUser.value})
                .then(response => {
                    const url = window.URL.createObjectURL(response.data);
                    const link: any = document.createElement("a");
                    link.href = url;
                    link.style = "display: none";
                    link.download = `Audit-Log-Export_${this.props.selectedUser.value}_${Date.now()}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    toastr.error(error.response.data.message);
                })
                .finally(() => {
                    this.setState({
                        loading: false
                    });
                })
        });
    };

    render() {
        const {resizeAction} = this.state;

        return (
            <div style={{width: "100%", height: "100%"}}>
                <div style={{height: 42, paddingLeft: 10}} className="bo-core-header top-header">
                    <div style={{float: "left", paddingLeft: 2, width: "100%", display: "flex"}}>
                        <input ref={"quickFilterBox"} onKeyDown={this.onFilterTextBoxChanged} onInput={this.onInput}
                               placeholder="🔍 Global search (press Shift-&#8593; and Shift-&#8595; to jump to column filters) "
                               className="new-design btn-new-design"
                               id={'audit-log-search'}
                               tabIndex={2}
                               style={{width: "100%", height: 36, fontSize: 18, marginRight: 2}} type="search"
                        />
                        <div className="control-buttons">
                            <button onClick={this.onFilterTextBoxChanged}
                                    style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design">
                                <GlobalSearchHelpToolTip/>
                                <i className="fas fa-search"/>
                                Search
                            </button>
                            <button id={'fit-content'} onClick={this.onResizeColumns} style={{marginRight: 2}}
                                    className={"btn btn-light btn-new-design"} title={'CTRL + ALT + F'}>
                                {resizeAction === ResizeActions.FIT_CONTENT ?
                                    <React.Fragment>
                                        <i className="fa fa-expand" style={{marginRight: 4}}/>
                                        <span style={{fontSize: '13px'}} className={'icon-style-text'}>
                                            <strong className={'shortcut-btn-letters'}>F</strong>it Content
                                        </span>
                                    </React.Fragment> :
                                    <React.Fragment>
                                        <i className="fas fa-compress-arrows-alt" style={{marginRight: 4}}/>
                                        <span style={{fontSize: '13px'}} className={'icon-style-text'}>
                                            <strong className={'shortcut-btn-letters'}>F</strong>it Screen
                                        </span>
                                    </React.Fragment>
                                }
                            </button>
                            <button
                                id={'view-log-btn'}
                                title={'View Log Entry (CTRL + ALT + V)'}
                                onClick={this.onViewLog}
                                style={{marginRight: 2}}
                                className={"btn btn-secondary btn-new-design"}>
                                <i className="fas fa-eye" style={{marginRight: 4}}/>
                                <span style={{fontSize: '13px'}} className={'icon-style-text'}>
                                    <strong className={'shortcut-btn-letters'}>V</strong>iew
                                </span>
                            </button>
                            <button
                                id={'export-log-btn'}
                                title={'Export Full Log (CTRL + ALT + E)'}
                                onClick={this.onLogExport}
                                className={"btn btn-secondary btn-new-design"}>
                                <i className="fas fa-file" style={{marginRight: 4}}/>
                                <span style={{fontSize: '13px'}} className={'icon-style-text'}>
                                    <strong className={'shortcut-btn-letters'}>E</strong>xport
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <LoadingModal open={this.state.loading}/>
                <div id="grid_container" style={{
                    height: "calc(100% - 68px)",
                    margin: 0,
                    padding: 10,
                    width: "100%",
                    backgroundColor: "#2D3436"
                }}>
                    <div className="ag-theme-balham-dark ag-grids"
                         style={{backgroundColor: "#2D3436", width: "100%", height: "100%"}}
                         id="AuditLogsGrid">
                        <AgGridReact
                            columnDefs      = {this.state.columnDefs}
                            defaultColDef   = {this.state.defaultColDef}
                            rowModelType    = {this.state.rowModelType}
                            onGridReady     = {this.onGridReady}
                            onFilterChanged={() => AgGridUtils.deselectAllRows(this.state.gridApi)}
                            gridOptions     = {this.gridOptions}
                            frameworkComponents = {this.state.frameworkComponents}
                        >
                        </AgGridReact>
                        <AgGridFooter
                            totalCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.
                                selectAllHeader.getState().totalItemsCount : 0}
                            loadedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.
                                selectAllHeader.getState().loadedItemsCount : 0}
                            selectedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.
                                selectAllHeader.getState().selectedItemsCount : 0}
                        />
                    </div>
                </div>
                <AuditLogChangesModal
                    onRef={(ref) => {
                        this.auditLogChangesRef = ref
                    }}
                    oldValue={this.state.logOldValue}
                    newValue={this.state.logNewValue}
                />
            </div>
        );
    }
}

const generateFilterData = (params: any): any => {
    const filter = {};
    const filterModel = params.request.filterModel;
    Object.keys(filterModel).map(key => {
        if (key !== "quickFilter") {
            const column = params.parentNode.gridApi.getColumnDef(key);
            if (column.dataType === AttributeTypeEnum.TIMESTAMP) {
                const inputDate = filterModel[key].filter.replace(
                    /\d{4}(-\d\d(-\d\d([T| ]\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?/g, function (a) {
                    if (Utils.moment(a, Utils.moment.ISO_8601).isValid()) {
                        const format: string = Utils.moment(a).creationData().format;
                        if (format === "YYYY-MM" || format === "YYYY-MM-DD") {
                            return a;
                        } else {
                            return Utils.localToUtc(a, format, format);
                        }

                    }
                    return a;
                });

                if (new RegExp(/^\d{4}\-\d{1,2}\-\d{1,2}$/).test(inputDate)) {
                    //YYYY-MM-DD
                    filter['stampAfter'] = Utils.moment(inputDate).format("YYYY-MM-DD") + 'T00:00:00';
                    filter['stampBefore'] = Utils.moment(inputDate).format("YYYY-MM-DD") + 'T23:59:59';
                } else if (new RegExp(/^\d{4}\-\d{1,2}\-\d{1,2}T\d{1,2}\:\d{1,2}$/).test(inputDate)) {
                    //YYYY-MM-DDT00:00
                    filter['stampAfter'] = inputDate + ':00';
                    filter['stampBefore'] = inputDate + ':59';
                } else if (new RegExp(/^>\d{4}\-\d{1,2}\-\d{1,2}$/).test(inputDate)) {
                    //>YYYY-MM-DD
                    filter['stampAfter'] = inputDate.split('>')[1] + 'T00:00:00';
                } else if (new RegExp(/^>\d{4}\-\d{1,2}\-\d{1,2}T\d{1,2}\:\d{1,2}$/).test(inputDate)) {
                    //>YYYY-MM-DDT00:00
                    filter['stampAfter'] = inputDate.split('>')[1] + ':00';
                } else if (new RegExp(/^<\d{4}\-\d{1,2}\-\d{1,2}$/).test(inputDate)) {
                    //<YYYY-MM-DD
                    filter['stampBefore'] = inputDate.split('<')[1] + 'T00:00:00';
                } else if (new RegExp(/^<\d{4}\-\d{1,2}\-\d{1,2}T\d{1,2}\:\d{1,2}$/).test(inputDate)) {
                    //<YYYY-MM-DDT00:00
                    filter['stampBefore'] = inputDate.split('<')[1] + ':00';
                } else if (new RegExp(/^\d{4}\-\d{1,2}\-\d{1,2}\::\d{4}\-\d{1,2}\-\d{1,2}$/).test(inputDate)) {
                    //YYYY-MM-DD::YYYY-MM-DD
                    filter['stampAfter'] = inputDate.split('::')[0] + 'T00:00:00';
                    filter['stampBefore'] = inputDate.split('::')[1] + 'T23:59:59';
                } else if (new RegExp(/^\d{4}\-\d{1,2}\-\d{1,2}T\d{1,2}\:\d{1,2}\::\d{4}\-\d{1,2}\-\d{1,2}T\d{1,2}\:\d{1,2}$/).test(inputDate)) {
                    //YYYY-MM-DDT00:00::YYYY-MM-DDT00:00
                    filter['stampAfter'] = inputDate.split('::')[0] + ':00';
                    filter['stampBefore'] = inputDate.split('::')[1] + ':59';
                }
                /*switch (filterModel[key].type) {
                    case 'equals':
                        filter['stampAfter'] = dateFrom + 'T00:00:00';
                        filter['stampBefore'] = dateFrom + 'T23:59:59';
                        break;
                    case 'greaterThanOrEqual':
                        filter['stampAfter'] = dateFrom + 'T00:00:00';
                        break;
                    case 'lessThanOrEqual':
                        filter['stampBefore'] = dateFrom + 'T00:00:00';
                        break;
                    case 'inRange':
                        filter['stampAfter'] = dateFrom + 'T00:00:00';
                        if (filterModel[key].dateTo) {
                            filter['stampBefore'] = filterModel[key].dateTo.replace(
                                /\d{4}(-\d\d(-\d\d([T| ]\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?/g, function (a) {
                                    if (Utils.moment(a, Utils.moment.ISO_8601).isValid()) {
                                        const format: string = Utils.moment(a).creationData().format;
                                        if (format === "YYYY-MM" || format === "YYYY-MM-DD") {
                                            return a;
                                        } else {
                                            return Utils.localToUtc(a, format, format);
                                        }
                                    }
                                    return a;
                                }) + 'T23:59:59';
                        }
                        break;
                }*/
            }
            else {
                filter[key] = filterModel[key].filter
            }
        }
    });
    return filter;
};

const generateSortData = (sortModel: any): any => {
    const sort = {};
    sortModel.map(item => {
        sort[item.colId] = item.sort
    });
    if (Object.keys(sort).length === 0) {
        sort['stamp'] = 'desc'
    }

    return sort;
};

export default AuditLogGrid



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/AuditLogGrid.tsx